import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import ExternalLinksAdditionalAttachments from "../Components/ExternalLinksAdditionalAttachments";
import { _Card, _CardHeading, _RequirementDescription, _CardContentWrapper } from "../style";
import { _DocumentCardContents } from "./style";
import useExternalLinks from "../../hooks/useExternalLinks";
import useAdditionalAttachments from "../../hooks/useAdditionalAttachments";
export default function DisclaimerRequirement(_ref) {
  var row = _ref.row;
  var externalLinks = useExternalLinks(row.requirement.id);
  var additionalAttachments = useAdditionalAttachments(row.requirement.id);
  var hasExternalLinkOrAdditionalAttachments = externalLinks.length > 0 || additionalAttachments.length > 0;
  return /*#__PURE__*/React.createElement(_Card, null, /*#__PURE__*/React.createElement(_DocumentCardContents, null, /*#__PURE__*/React.createElement(_CardContentWrapper, null, /*#__PURE__*/React.createElement(_CardHeading, null, row.requirement.title), /*#__PURE__*/React.createElement(_RequirementDescription, {
    dangerouslySetInnerHTML: {
      __html: row.requirement.description
    }
  }), hasExternalLinkOrAdditionalAttachments && /*#__PURE__*/React.createElement(ExternalLinksAdditionalAttachments, {
    externalLinks: externalLinks,
    additionalAttachments: additionalAttachments
  }))));
}